import React from 'react';
import './Button.scss';

const Button = ({ children, onClick, type = 'button', variant = 'primary', size = 'medium', disabled = false, className = '' }) => {
    const baseClass = `btn btn-${variant} btn-${size} ${className}`;
    return (
        <button type={type} className={baseClass} onClick={onClick} disabled={disabled}>
            {children}
        </button>
    );
};

export default Button;
